export default __webpack_public_path__ + "static/media/gallery.ee8d448a.svg";